import React, { useState } from 'react';
import { Dispatch, SetStateAction } from 'react';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button, Select, SelectChangeEvent, MenuItem } from '@mui/material'
import { NOTIFICATION_TYPE, ROLES } from '../utils/enums';
import { showError, showToast } from '../constants/toasts';
import { useAddNotificationMutation } from '../services/notifications';

interface AddNotificationModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>
    getAllNotifications:() => void
}

export default function AddNotification({ open, onClose, setOpen,getAllNotifications }: AddNotificationModalProps) {


    const [title, setTitle] = useState<string>("")
    const [message, setMessage] = useState<string>("")
    const [type, setType] = useState<number>(0)
    const [role, setRole] = useState<number>(0)

    const [selectField1, setSelectField1] = React.useState('default');

    const [addNotification] = useAddNotificationMutation()
    const [error, setError] = useState(false)
    const handleChange1 = (event: SelectChangeEvent) => {
        setSelectField1(event.target.value as string);
    };
    const handleRole = (event: SelectChangeEvent) => {
        setRole(Number(event.target.value))
    }
    const handleType = (event: SelectChangeEvent) => {
        setType(Number(event.target.value))
    }

    const handleCancel = () => {
        setOpen(false)
        setRole(0)
        setType(0)
        setMessage('')
        setTitle('')
    }

    const handleSubmit = async () => {
        if (!title || !message || !role || !type) {
            console.log(title, message, role, type)
            return
        }
        console.log(title, message, role, type)
        setOpen(false)
        const body = {
            type,
            role,
            title,
            message
        }
        // console.log(body)
        try {
            const response = await addNotification(body).unwrap();

            if (response?.statusCode === 200) {
                showToast("Notification added successfully");
            }
        } catch (error: any) {
            showError(error.message)
        } finally {
            getAllNotifications()
            setTitle('')
            setMessage('')
            setType(0)
            setRole(0)

            //   setIsLoading(false);
        }

    }

    return (
        <Modal
            className="modal addNotification_modal"
            id="addNotificationModal"
            aria-labelledby="addNotification-modal-title"
            aria-describedby="addNotification-modal-description"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Add Notification</h2>
                        <div className="btn-close" onClick={handleCancel}>
                            <CloseIcon />
                        </div>
                    </div>
                    <form className="form" action="">
                        <div className="gap_p">
                            <div className="control_group w_100">
                                <TextField
                                    variant="outlined"
                                    placeholder="Notification Title"
                                    fullWidth
                                    hiddenLabel
                                    value={title}
                                    onChange={(e) => {
                                        setTitle(e.target.value)
                                    }}
                                /> {error && !title ? (
                                    <h6 className="err_msg">Notification title is required</h6>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div className="control_group w_50">
                                <Select
                                    fullWidth
                                    value={String(role)}
                                    onChange={handleRole}
                                >
                                    <MenuItem disabled value={0}>Select Send To</MenuItem>
                                    <MenuItem value={ROLES.USER}>Customers</MenuItem>
                                    <MenuItem value={ROLES.SUB_ADMIN}>Sub-Admin</MenuItem>
                                    <MenuItem value={ROLES.MAINTAINER}>Maintenance Team</MenuItem>
                                    <MenuItem value={5}>Select All</MenuItem>
                                </Select>
                                {error && !role ? (
                                    <h6 className="err_msg">Notification title is required</h6>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div className="control_group w_50">
                                <Select
                                    fullWidth
                                    labelId="type"
                                    id="type"
                                    value={String(type)}
                                    onChange={handleType}
                                >
                                    <MenuItem disabled value={0}>Select Type</MenuItem>
                                    <MenuItem value={NOTIFICATION_TYPE.MAIL}>Email</MenuItem>
                                    <MenuItem value={NOTIFICATION_TYPE.PUSH}>Push</MenuItem>
                                </Select>
                                {error && !type ? (
                                    <h6 className="err_msg">Notification title is required</h6>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div className="control_group w_100">
                                <TextField
                                    variant="outlined"
                                    placeholder="Notification Message"
                                    fullWidth
                                    hiddenLabel
                                    value={message}
                                    multiline
                                    onChange={(e) => {
                                        setMessage(e.target.value)
                                    }}
                                    maxRows={5}
                                    minRows={5}
                                />
                                {error && !message ? (
                                    <h6 className="err_msg">Notification title is required</h6>
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                        <div className="footer_btn_flex">
                            <Button className="btn btn_grey" onClick={handleCancel}>Cancel</Button>
                            <Button className="btn btn_primary" onClick={() => {
                                setError(true)
                                if (!title || !message || !role || !type) {
                                    return
                                }
                                setError(false)
                                handleSubmit()
                            }
                            }>Submit</Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal >
    )
}
